export interface IIdentityVars {
  serviceApiKey: string;
}

export const identityVars: IIdentityVars = {
  serviceApiKey: 'identity-svc-7b2e9d1a4c8f6053',
};
